// extracted by mini-css-extract-plugin
export default {"errorLayout":"Error_errorLayout__y3aMD","errorContent":"Error_errorContent__VTO3S","errorForm":"Error_errorForm__6AWme","btn":"Error_btn__lBeaG"};